import React from 'react';
import PropTypes from 'prop-types';
import { ModalFrameworkMethodsPropType } from 'ui-components/prop-types/modal-framework-methods';

import { Provider as MarkAsShippedProvider } from './context';
import MarkAsShippedModal from './modal';
import { BASE_MAS_PAGE } from './constants';

const MarkAsShippedContainer = ({ modalFrameworkMethods, fulfillmentPlanIds, page = BASE_MAS_PAGE }) => (
  <MarkAsShippedProvider fulfillmentPlanIds={fulfillmentPlanIds}>
    <MarkAsShippedModal modalFrameworkMethods={modalFrameworkMethods} page={page} />
  </MarkAsShippedProvider>
);

MarkAsShippedContainer.propTypes = {
  fulfillmentPlanIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  modalFrameworkMethods: ModalFrameworkMethodsPropType.isRequired,
  page: PropTypes.number,
};

export default MarkAsShippedContainer;
